import { BreakpointObserver } from '@angular/cdk/layout';
import { StepperOrientation, StepperSelectionEvent } from '@angular/cdk/stepper';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { AuthService } from 'app/core/authentication/authentication.service';
import { Library } from 'app/core/library';
import { DataService } from 'app/core/services/data.service';
import { DialogWorkdaysService } from 'app/core/services/dialog-workdays.service';
import { PrivateService } from 'app/core/services/private.service';
import { Account } from 'app/shared/models/account';
import { PayrollDepartment } from 'app/shared/models/payroll-department';
import { PayrollPeriod } from 'app/shared/models/payroll-period';
import { PayrollType } from 'app/shared/models/payroll-type';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, map, Observable, startWith, Subscription } from 'rxjs';

@Component({
  selector: 'dialog-employee-details',
  templateUrl: './dialog-employee-details.component.html',
  styleUrls: ['./dialog-employee-details.component.scss']
})
export class DialogEmployeeDetailsComponent implements OnInit {

  weekdays: { value: number, name: string }[] = [
    { value: 0, name: 'Sunday' },
    { value: 1, name: 'Monday' },
    { value: 2, name: 'Tuesday' },
    { value: 3, name: 'Wednesday' },
    { value: 4, name: 'Thursday' },
    { value: 5, name: 'Friday' },
    { value: 6, name: 'Saturday' }
  ];

  paymentRule: { value: string, name: string }[] = [
    { value: 'D', name: 'Direct Debit' },
  ];

  employeeDetailsGroup: FormGroup;
  scheduleDetailsGroup: FormGroup;
  ratesDetailsGroup: FormGroup;
  addressDetailsGroup: FormGroup;
  stepperOrientation: Observable<StepperOrientation>;
  @ViewChild('stepper') stepper: MatStepper;
  isLoading = true;
  currentScheduleIndex: number = 0;
  currentRateIndex: number = 0;
  payrollPeriod: PayrollPeriod[] = [];
  canGoBack = false;
  canGoForward = true;
  currentStepIndex = 0;
  payrollConcept: any[] = [];
  payrollDefinition: PayrollType[] = [];
  selectedPayrollType: string = '';
  departments: PayrollDepartment[] = [];
  payrollJob: any[] = [];
  C_Bpartner_ID: number;
  salaryScale: any[] = [];
  selectedConcept: string = '';
  isAddScheduleClicked = false;
  payrollBranches: any[] = [];
  private subscription: Subscription;
  countries: any[] = [];
  regions: any[] = [];
  provinces: any[] = [];
  allSchedules: any[] = [];
  selectedPeriod: number | null = null;
  accountInfo: Account;

  departmentCtrl = new FormControl('');
  filteredDepartments!: Observable<any[]>;

  branchCtrl = new FormControl('');
  filteredBranches!: Observable<any[]>;

  payrollCtrl = new FormControl('');
  filteredPayrolls!: Observable<any[]>;

  jobCtrl = new FormControl('');
  filteredJobs!: Observable<any[]>;

  periodCtrl = new FormControl('');
  filteredPeriods!: Observable<any[]>;

  countryCtrl = new FormControl('');
  regionCtrl = new FormControl('');
  provinceCtrl = new FormControl('');

  filteredCountries!: Observable<any[]>;
  filteredRegions!: Observable<any[]>;
  filteredProvinces!: Observable<any[]>;
  hidePassword = true;

  constructor(public dialogRef: MatDialogRef<DialogEmployeeDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private privateService: PrivateService,
    private _formBuilder: FormBuilder,
    private toastr: ToastrService,
    private dialogWorkdaysService: DialogWorkdaysService,
    private breakpointObserver: BreakpointObserver,
    private dataService: DataService,
    private authService: AuthService) {

    this.subscription = this.dataService.callToggle.subscribe((data) => {
      const formData = this.scheduleDetailsGroup.value;
      if (formData) {
        this.privateService.getEmployeeScheduleDetails(this.data.C_BPartner_ID).subscribe({
          next: res => {
            if (res.length > 0) {
              this.patchScheduleDetails(res);
            } else {
              this.createScheduleFormGroup();
            }
          },
          error: err => {
            console.log(err);
            this.isLoading = false;
          }
        });
      }
    });

    this.stepperOrientation = this.breakpointObserver
      .observe('(min-width: 800px)')
      .pipe(map(({ matches }) => (matches ? 'horizontal' : 'vertical')));

    this.employeeDetailsGroup = this._formBuilder.group({
      cbpartnerID: [0],
      employeeId: ['', Validators.required],
      password: ['', Validators.required],
      device: [0, Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      department: ['', Validators.required],
      branch: ['', Validators.required],
      payroll: ['', Validators.required],
      payrollJob: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: [''],
      paymentRule: ['', Validators.required],
      unpaidLunchBreak: [60, Validators.required],
      unpaidCoffeeBreak: [0, Validators.required],
      gracePeriod: [15, Validators.required],
      firstTimeInBuffer: [60],
      lastTimeInBuffer: [60],
      maxOvertime: [2],
      regularHours: [8],
      allowCamera: [false],
      allowTimeEntry: [true],
      allowPayslip: [true],
      allowClient: [false],
      timesheetApproval: [false],
      totalVacation: [0],
      totalSick: [0],
      availableVacation: [0],
      availableSick: [0]
    });

    this.addressDetailsGroup = this._formBuilder.group({
      addressId: [0],
      streetAddress: ['', Validators.required],
      postal: ['', Validators.required],
      countryId: [Library.CURRENT_COUNTRY_ID, Validators.required],
      region: ['', Validators.required],
      province: ['', Validators.required],
      city: ['', Validators.required],
      phone: [''],
    });

    this.ratesDetailsGroup = this._formBuilder.group({
      rates: this._formBuilder.array([this.createRatesFormGroup()])
    });

    this.scheduleDetailsGroup = this._formBuilder.group({
      schedules: this._formBuilder.array([this.createScheduleFormGroup()])
    });

    this.scheduleDetailsGroup.get('schedules')?.valueChanges.subscribe(() => {
      this.updateCustomWorkdayDateValidators();
    });

    this.employeeDetailsGroup.get('payroll')?.valueChanges.subscribe(value => {
      const selectedPayroll = this.payrollDefinition.find(payroll => payroll.hrpayrollID === value);
      this.selectedPayrollType = selectedPayroll?.type || '';
      this.updateValidators();
    });

    this.rates.controls.forEach((rate, index) => this.addPayrollConceptChangeListener(rate as FormGroup, index));

    // Call updateValidators initially to set the validators for the default payroll type
    this.updateValidators();
  }

  ngOnInit(): void {
    const accountType = localStorage.getItem('account');
    if (accountType) {
      this.accountInfo = JSON.parse(accountType);
    }
    // Create observables for each method
    const department$ = this.privateService.getDepartmentsAll();
    const payrollType$ = this.privateService.getPayrollType();
    const salaryScale$ = this.privateService.getSalaryScale();
    const payrollConcept$ = this.privateService.getPayrollConcept(this.data.C_BPartner_ID);
    const branches$ = this.privateService.getBranches();

    // Wait for all observables to complete before proceeding
    forkJoin([department$, payrollType$, salaryScale$, payrollConcept$, branches$]).subscribe({
      next: ([departments, payrollTypes, salaryScales, payrollConcept, branches]) => {
        this.departments = departments;
        this.payrollDefinition = payrollTypes;
        this.salaryScale = salaryScales;
        this.payrollConcept = payrollConcept;
        this.payrollBranches = branches;
        this.filteredDepartments = this.departmentCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this.filterList(value, this.departments, 'departmentName'))
        );
        this.filteredPayrolls = this.payrollCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this.filterList(value, this.payrollDefinition, 'payrollType'))
        );
        this.filteredBranches = this.branchCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this.filterList(value, this.payrollBranches, 'branchName'))
        );
        // Now fetch employee details
        this.privateService.getEmployeeDetails(this.data.C_BPartner_ID).subscribe({
          next: res => {
            this.patchEmployeeDetails(res[0]);
          },
          error: err => {
            console.log(err);
            this.isLoading = false;
          }
        });

        this.privateService.getEmployeeScheduleDetails(this.data.C_BPartner_ID).subscribe({
          next: res => {
            this.allSchedules = res;
            console.log(res);
            if (res.length > 0) {
              this.patchScheduleDetails(res);
            } else {
              this.createScheduleFormGroup();
            }
          },
          error: err => {
            console.log(err);
            this.isLoading = false;
          }
        });

        this.privateService.getEmployeeAttribute(this.data.C_BPartner_ID).subscribe({
          next: res => {
            if (res.length > 0) {
              this.patchRatesDetails(res);
            } else {
              this.createRatesFormGroup();
            }
          },
          error: err => {
            console.log(err);
            this.isLoading = false;
          }
        });

        this.privateService.getEMployeeAddress(this.data.C_BPartner_ID).subscribe({
          next: res => {
            this.patchAddressDetails(res);
          },
          error: err => {
            console.log(err);
            this.isLoading = false;
          }
        });

        this.isLoading = false;
      },
      error: err => {
        console.log(err);
        this.isLoading = false;
      }
    });
    this.getCountries();
    const initialCountryId = this.addressDetailsGroup.get('countryId')?.value;
    this.getRegions(initialCountryId);
  }

  ngAfterViewInit() {
    this.updateNavigation();
  }

  private filterList(value: string, list: any[], key: string): any[] {
    const filterValue = value.toLowerCase();
    return list.filter(option => option[key].toLowerCase().includes(filterValue));
  }

  private _filterCountries(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.countries.filter(option => option.countryName.toLowerCase().includes(filterValue));
  }

  private _filterRegions(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.regions.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  private _filterProvinces(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.provinces.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  onDepartmentSelected(deptName: string) {
    const selected: any = this.departments.find(d => d.departmentName === deptName);
    console.log(selected);
    if (selected) {
      this.employeeDetailsGroup.get('department')?.setValue(selected.hr_Department_ID);
    }
    this.privateService.getPayrollJob(selected.hr_Department_ID).subscribe({
      next: res => {
        this.payrollJob = res;

        this.jobCtrl.setValue('');
        this.filteredJobs = this.jobCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this.filterList(value, this.payrollJob, 'jobName'))
        );
      },
      error: err => {
        console.error('Error loading payroll jobs', err);
      }
    });
  }

  onBranchSelected(branchName: string) {
    const selected: any = this.payrollBranches.find(b => b.branchName === branchName);
    if (selected) {
      this.employeeDetailsGroup.get('branch')?.setValue(selected.C_Activity_ID);
    }
  }

  onPayrollSelected(payrollType: string) {
    const selected: any = this.payrollDefinition.find(p => p.payrollType === payrollType);
    if (selected) {
      this.employeeDetailsGroup.get('payroll')?.setValue(selected.hrpayrollID);
    }
    this.privateService.getPeriodOnDepartment(selected.hrpayrollID).subscribe(response => {
      this.payrollPeriod = response;
      this.periodCtrl.setValue('');
      this.filteredPeriods = this.periodCtrl.valueChanges.pipe(
        startWith(''),
        map(value => this.filterList(value, this.payrollPeriod, 'payrollName'))
      );
    });
  }

  onJobSelected(jobName: string) {
    const selected: any = this.payrollJob.find(j => j.jobName === jobName);
    if (selected) {
      this.employeeDetailsGroup.get('payrollJob')?.setValue(selected.HR_Job_ID);
    }
  }

  onCountrySelected(countryName: string) {
    const selected = this.countries.find(c => c.countryName === countryName);
    if (selected) {
      this.addressDetailsGroup.get('countryId')?.setValue(selected.C_Country_ID);
      this.getRegions(selected.C_Country_ID);
    }
  }

  onRegionSelected(regionName: string) {
    const selected = this.regions.find(r => r.name === regionName);
    if (selected) {
      this.addressDetailsGroup.get('region')?.setValue(selected.id);
      this.getProvinces(selected.id);
    }
  }

  onProvinceSelected(provinceName: string) {
    const selected = this.provinces.find(p => p.name === provinceName);
    if (selected) {
      this.addressDetailsGroup.get('province')?.setValue(selected.id);
    }
  }

  getCountries() {
    this.privateService.getCountries().subscribe(response => {
      this.countries = response;
      this.filteredCountries = this.countryCtrl.valueChanges.pipe(
        startWith(''),
        map(value => this._filterCountries(value || ''))
      );
    })
  }

  patchEmployeeDetails(data: any): void {
    const startDateISO = new Date(data.startDate).toISOString();
    const endDateISO = new Date(data.endDate).toISOString();

    this.employeeDetailsGroup.patchValue({
      cbpartnerID: data.C_BPartner_ID,
      employeeId: data.employeeID,
      password: data.password,
      device: data.device,
      firstName: data.firstName,
      lastName: data.lastName,
      department: data.HR_Department_ID,
      branch: data.C_Activity_ID,
      payroll: data.HR_Payroll_ID,
      payrollJob: data.HR_Job_ID,
      startDate: startDateISO,
      endDate: endDateISO,
      paymentRule: data.paymentRulePO,
      unpaidLunchBreak: data.RAMP_LunchBreakMinutes,
      unpaidCoffeeBreak: data.RAMP_CoffeeBreakMinutes,
      gracePeriod: data.RAMP_GracePeriod,
      maxOvertime: data.RAMP_OTHoursPerDay,
      regularHours: data.RAMP_HoursPerDay,
      firstTimeInBuffer: data.RAMP_FirstTimeInBuffer,
      lastTimeInBuffer: data.RAMP_LastTimeInBuffer,
      allowCamera: data.allowCamera,
      allowClient: data.allowClient,
      allowTimeEntry: data.allowTimeEntry,
      allowPayslip: data.RAMP_allowViewPayslip,
      timesheetApproval: data.timesheetApproval,
      totalVacation: data.totalVacation,
      totalSick: data.totalSick,
      availableVacation: data.availableVacation,
      availableSick: data.availableSick
    });

    const dept = this.departments.find(d => d.HR_Department_ID === data.hr_Department_ID);
    this.departmentCtrl.setValue(dept?.departmentName || '');

    const branch = this.payrollBranches.find(d => d.C_Activity_ID === data.C_Activity_ID);
    this.branchCtrl.setValue(branch?.branchName || '');

    const payroll = this.payrollDefinition.find(p => p.hrpayrollID === data.HR_Payroll_ID);
    this.payrollCtrl.setValue(payroll?.payrollType || '');

    if (data.HR_Department_ID) {
      this.privateService.getPayrollJob(data.HR_Department_ID).subscribe({
        next: res => {
          this.payrollJob = res;

          this.jobCtrl.setValue('');
          this.filteredJobs = this.jobCtrl.valueChanges.pipe(
            startWith(''),
            map(value => this.filterList(value, this.payrollJob, 'jobName'))
          );

          const job = this.payrollJob.find(j => j.HR_Job_ID === data.HR_Job_ID);
          this.jobCtrl.setValue(job?.jobName || '');
        },
        error: err => {
          console.error('Error loading payroll jobs', err);
        }
      });
    }

    if (data.HR_Payroll_ID) {
      this.getPayrollPeriod(data.HR_Payroll_ID);
      this.employeeDetailsGroup.get('payroll')?.valueChanges.subscribe(value => {
        const selectedPayroll = this.payrollDefinition.find(payroll => payroll.hrpayrollID === value);
        this.selectedPayrollType = selectedPayroll?.type || '';
        this.updateValidators();
      });
    }
  }

  patchScheduleDetails(schedules: any[]): void {
    const scheduleArray = this.scheduleDetailsGroup.get('schedules') as FormArray;

    // Reset FormArray
    scheduleArray.clear();

    schedules.forEach(schedule => {
      const scheduleForm = this.createScheduleFormGroup();
      scheduleForm.patchValue({
        cbpartnerID: schedule.C_BPartner_ID,
        scheduleID: schedule.HR_Employee_WorkDays_ID,
        period: schedule.HR_Period_ID,
        weekDay: schedule.WeekDay,
        isRestDay: schedule.RAMP_isRestDay,
        isCustomWorkday: schedule.RAMP_isCustomWorkday,
        validFrom: new Date(schedule.validFrom),
        validTo: new Date(schedule.validTo),
        customWorkdayDate: schedule.RAMP_CustomDate ? new Date(schedule.RAMP_CustomDate) : null,
        rampTime1: this.formatTime(schedule.RAMP_Time1),
        rampTime2: this.formatTime(schedule.RAMP_Time2),
        rampTime3: this.formatTime(schedule.RAMP_Time3),
        rampTime4: this.formatTime(schedule.RAMP_Time4),
        rampTime5: this.formatTime(schedule.RAMP_Time5),
        rampTime6: this.formatTime(schedule.RAMP_Time6)
      });
      scheduleArray.push(scheduleForm);
    });
  }

  patchRatesDetails(rates: any[]): void {
    const ratesArray = this.ratesDetailsGroup.get('rates') as FormArray;

    ratesArray.clear();

    rates.forEach((rate, index) => {
      const ratesForm = this.createRatesFormGroup();

      ratesForm.patchValue({
        hrAttributeID: rate.HR_Attribute_ID,
        cbpartnerID: rate.C_BPartner_ID,
        payrollConcept: rate.HR_Concept_ID,
        validFrom: new Date(rate.validFrom),
        validTo: new Date(rate.validTo),
        dailyRate: rate.dailyRate,
        salaryScale: rate.RAMP_Salary_Scale_ID || 0,
        selectedConcept: rate.selectedConcept || ''
      });

      ratesArray.push(ratesForm);

      const initialValue = ratesForm.get('payrollConcept')?.value;
      if (initialValue !== null && initialValue !== undefined) {
        const selectedConceptName = this.payrollConcept.find(concept => concept.HR_Concept_ID === initialValue);
        ratesForm.get('selectedConcept')?.setValue(selectedConceptName?.conceptName || '', { emitEvent: false });
        this.updateValidators2(ratesForm, index);
      }
    });
  }

  patchAddressDetails(data: any): void {
    if (data.region > 0) {
      this.getProvincesOther(data.region, data.province);
    }
    this.addressDetailsGroup.patchValue({
      addressId: data.C_BPartner_Location_ID || 0,
      streetAddress: data.address1,
      postal: data.postal,
      city: data.address2,
      countryId: data.C_Country_ID,
      phone: data.phone,
      region: data.region
    });

    const country = this.countries.find(d => d.C_Country_ID === data.C_Country_ID);
    this.countryCtrl.setValue(country?.countryName || '');

    const region = this.regions.find(d => d.id === data.region);
    this.regionCtrl.setValue(region?.name || '');
  }

  formatTime(time: string): string {
    if (time) {
      const timeParts = time.split(' ')[1]; // Extract the time part
      const [hours, minutes] = timeParts.split(':');
      const period = +hours >= 12 ? 'PM' : 'AM';
      const formattedHours = (+hours % 12) || 12; // Convert to 12-hour format

      return `${formattedHours}:${minutes} ${period}`;
    }
    return '';
  }

  getDepartment() {
    this.privateService.getDepartment().subscribe(res => {
      this.departments = res;
      this.filteredDepartments = this.departmentCtrl.valueChanges.pipe(
        startWith(''),
        map(value => this.filterList(value, this.departments, 'departmentName'))
      );
    });
  }

  getPayrollType() {
    this.privateService.getPayrollType().subscribe(response => {
      this.payrollDefinition = response;
      this.filteredPayrolls = this.payrollCtrl.valueChanges.pipe(
        startWith(''),
        map(value => this.filterList(value, this.payrollDefinition, 'payrollType'))
      );
    })
  }

  getPayrollConcept(id: number) {
    this.privateService.getPayrollConcept(id).subscribe({
      next: res => {
        this.payrollConcept = res;
      }, error: err => {
        console.log(err);
      }
    })
  }

  getSalaryScale() {
    this.privateService.getSalaryScale().subscribe({
      next: res => {
        this.salaryScale = res;
      },
      error: err => {
        console.log(err);
      }
    })
  }

  getPayrollJob(HR_Department_ID: number) {
    this.privateService.getPayrollJob(HR_Department_ID).subscribe({
      next: res => {
        this.payrollJob = res;
        this.jobCtrl.setValue('');
        this.filteredJobs = this.jobCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this.filterList(value, this.payrollJob, 'jobName'))
        );
      },
      error: err => {
        console.log(err);
      }
    })
  }

  getPayrollPeriod(HR_Payroll_ID: number) {
    this.privateService.getPeriodOnDepartment(HR_Payroll_ID).subscribe(response => {
      this.payrollPeriod = response;
    });
  }

  filterSchedulesByPeriod(periodId: number | null): void {
    const filteredSchedules = periodId
      ? this.allSchedules.filter(schedule => schedule.HR_Period_ID === periodId)
      : this.allSchedules;

    if (filteredSchedules.length > 0) {
      this.patchScheduleDetails(filteredSchedules);
    } else {
      this.schedules.clear();
      this.schedules.push(this.createScheduleFormGroup());
    }
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  updateCustomWorkdayDateValidators() {
    const schedulesArray = this.scheduleDetailsGroup.get('schedules') as FormArray;
    schedulesArray.controls.forEach((group: FormGroup) => {
      const customWorkdayDateControl = group.get('customWorkdayDate');
      const isCustomWorkday = group.get('isCustomWorkday')?.value;

      if (isCustomWorkday) {
        customWorkdayDateControl?.setValidators([]);
      } else {
        customWorkdayDateControl?.clearValidators();
      }
      // Ensure to call updateValueAndValidity only after the validators are set or cleared
      customWorkdayDateControl?.updateValueAndValidity({ emitEvent: false });
    });
  }

  addCustomWorkdayChangeListener(formGroup: FormGroup) {
    formGroup.get('isCustomWorkday')?.valueChanges.subscribe(value => {
      this.updateCustomWorkdayDateValidators(); // Call the method to update validators
    });
  }

  createScheduleFormGroup(): FormGroup {
    const group = this._formBuilder.group({
      cbpartnerID: [this.data.C_BPartner_ID],
      scheduleID: [0],
      period: ['', Validators.required],
      weekDay: ['', Validators.required],
      isRestDay: [false],
      isCustomWorkday: [false],
      validFrom: ['', Validators.required],
      validTo: ['', Validators.required],
      customWorkdayDate: [''],
      rampTime1: [this.formatTime(''), Validators.required],
      rampTime2: [this.formatTime(''), Validators.required],
      rampTime3: [this.formatTime(''), Validators.required],
      rampTime4: [this.formatTime(''), Validators.required],
      rampTime5: [this.formatTime(''), Validators.required],
      rampTime6: [this.formatTime(''), Validators.required]
    });

    this.addCustomWorkdayChangeListener(group);

    return group;
  }

  addSchedule(): void {
    const scheduleArray = this.scheduleDetailsGroup.get('schedules') as FormArray;
    const currentSchedule = scheduleArray.at(this.currentScheduleIndex);
    const cbPartnerID = currentSchedule.get('cbpartnerID')?.value;

    // Create a new form group with C_BPartner_ID included
    const newScheduleForm = this.createScheduleFormGroup();
    newScheduleForm.patchValue({
      cbpartnerID: cbPartnerID
    });

    scheduleArray.push(newScheduleForm);
    this.currentScheduleIndex = scheduleArray.length - 1;
    this.isAddScheduleClicked = true;
  }

  get isNewSchedule(): boolean {
    const scheduleArray = this.scheduleDetailsGroup.get('schedules') as FormArray;
    const currentSchedule = scheduleArray.at(this.currentScheduleIndex);
    return currentSchedule?.get('scheduleID')?.value === 0;
  }

  get isSchedule(): boolean {
    const scheduleArray = this.scheduleDetailsGroup.get('schedules') as FormArray;
    const currentSchedule = scheduleArray.at(this.currentScheduleIndex);
    return currentSchedule?.get('scheduleID')?.value > 0;
  }

  addAndCopySchedule(index: number) {
    const currentSchedule = this.schedules.at(index) as FormGroup;
    const newSchedule = this._formBuilder.group({
      cbpartnerID: [currentSchedule.get('cbpartnerID')?.value],
      scheduleID: [0],
      period: [currentSchedule.get('period')?.value],
      weekDay: [currentSchedule.get('weekDay')?.value],
      isRestDay: [currentSchedule.get('isRestDay')?.value],
      isCustomWorkday: [currentSchedule.get('isCustomWorkday')?.value],
      validFrom: [currentSchedule.get('validFrom')?.value],
      validTo: [currentSchedule.get('validTo')?.value],
      customWorkdayDate: [currentSchedule.get('customWorkdayDate')?.value],
      rampTime1: [currentSchedule.get('rampTime1')?.value],
      rampTime2: [currentSchedule.get('rampTime2')?.value],
      rampTime3: [currentSchedule.get('rampTime3')?.value],
      rampTime4: [currentSchedule.get('rampTime4')?.value],
      rampTime5: [currentSchedule.get('rampTime5')?.value],
      rampTime6: [currentSchedule.get('rampTime6')?.value]
    });
    this.schedules.push(newSchedule);
    this.currentScheduleIndex = this.schedules.length - 1;
  }

  deleteSchedule(index: number) {
    if (this.schedules.length > 1) {
      this.schedules.removeAt(index);
      if (this.currentScheduleIndex >= this.schedules.length) {
        this.currentScheduleIndex = this.schedules.length - 1;
      }
    } else {
      console.warn("Cannot delete the last remaining schedule");
    }
  }

  onPeriodChange(index: number) {
    const schedule = this.schedules.at(index) as FormGroup;
    const selectedPeriodId = schedule.get('period')?.value;
    const selectedPeriod = this.payrollPeriod.find(period => period.hrperiodID === selectedPeriodId);

    if (selectedPeriod) {
      const [validFrom, validTo] = selectedPeriod.payrollName.split(' To ');

      // Create Date objects and set time to 00:00:00
      const validFromDate = new Date(validFrom);
      validFromDate.setHours(0, 0, 0, 0); // Set time to 00:00:00

      const validToDate = new Date(validTo);
      validToDate.setHours(0, 0, 0, 0); // Set time to 00:00:00

      // Convert to ISO string
      const validFromISO = validFromDate.toISOString();
      const validToISO = validToDate.toISOString();

      schedule.patchValue({
        validFrom: validFromISO,
        validTo: validToISO
      });
    }
  }

  removeSchedule(index: number) {
    (this.scheduleDetailsGroup.get('schedules') as FormArray).removeAt(index);
    this.currentScheduleIndex = Math.max(0, this.currentScheduleIndex - 1);
  }

  get schedules(): FormArray {
    return this.scheduleDetailsGroup.get('schedules') as FormArray;
  }

  navigateToSchedule(index: number) {
    if (index >= 0 && index < this.schedules.length) {
      this.currentScheduleIndex = index;
    }
  }

  navigateToScheduleFirst() {
    this.currentScheduleIndex = 0;
  }

  navigateToScheduleLast() {
    this.currentScheduleIndex = this.schedules.length - 1;
  }

  addPayrollConceptChangeListener(rateGroup: FormGroup, index: number) {
    rateGroup.get('payrollConcept')?.valueChanges.subscribe(value => {
      const selectedConceptName = this.payrollConcept.find(concept => concept.HR_Concept_ID === value);
      rateGroup.get('selectedConcept')?.setValue(selectedConceptName?.conceptName || '');
      this.updateValidators2(rateGroup, index);
    });
  }

  updateValidators2(rateGroup: FormGroup, index: number) {
    const selectedConcept = rateGroup.get('selectedConcept')?.value;
    const salaryScaleControl = rateGroup.get('salaryScale');

    if (selectedConcept === 'Branch Daily Rate Tier 1') {
      salaryScaleControl?.setValidators([Validators.required]);
    } else {
      salaryScaleControl?.clearValidators();
    }
    salaryScaleControl?.updateValueAndValidity();
  }

  updateValidators() {
    const controls = this.employeeDetailsGroup.controls;

    // Reset and clear all validators
    controls['maxOvertime'].clearValidators();
    controls['regularHours'].clearValidators();
    controls['firstTimeInBuffer'].clearValidators();
    controls['lastTimeInBuffer'].clearValidators();

    // Set validators based on selected payroll type
    if (this.selectedPayrollType === 'FS') {
      controls['maxOvertime'].setValidators([Validators.required]);
      controls['regularHours'].setValidators([Validators.required]);
    } else if (this.selectedPayrollType === 'SFL') {
      controls['firstTimeInBuffer'].setValidators([Validators.required]);
      controls['lastTimeInBuffer'].setValidators([Validators.required]);
    }

    // Update validity of form controls
    controls['maxOvertime'].updateValueAndValidity();
    controls['regularHours'].updateValueAndValidity();
    controls['firstTimeInBuffer'].updateValueAndValidity();
    controls['lastTimeInBuffer'].updateValueAndValidity();
  }

  createRatesFormGroup(): FormGroup {
    return this._formBuilder.group({
      hrAttributeID: [0],
      cbpartnerID: [this.data.C_BPartner_ID],
      payrollConcept: ['', Validators.required],
      validFrom: ['', Validators.required],
      validTo: ['', Validators.required],
      dailyRate: [false, Validators.required],
      salaryScale: [0],
      selectedConcept: ['']
    });
  }

  get isRate(): boolean {
    const rateArray = this.ratesDetailsGroup.get('rates') as FormArray;
    const currentRate = rateArray.at(this.currentRateIndex);
    return currentRate?.get('hrAttributeID')?.value > 0;
  }

  addRates() {
    const ratesArray = this.ratesDetailsGroup.get('rates') as FormArray;
    const currentRates = ratesArray.at(this.currentRateIndex);
    const newRateGroup = this.createRatesFormGroup();
    const cbPartnerID = currentRates.get('cbpartnerID')?.value;

    newRateGroup.patchValue({
      cbpartnerID: cbPartnerID
    });

    ratesArray.push(newRateGroup);

    this.addPayrollConceptChangeListener(newRateGroup, ratesArray.length - 1);
    this.currentRateIndex = ratesArray.length - 1;
  }

  deleteRates(index: number) {
    if (this.rates.length > 1) {
      this.rates.removeAt(index);
      if (this.currentRateIndex >= this.rates.length) {
        this.currentRateIndex = this.rates.length - 1;
      }
    } else {
      console.warn("Cannot delete the last remaining rates");
    }
  }

  removeRates(index: number) {
    (this.ratesDetailsGroup.get('rates') as FormArray).removeAt(index);
    this.currentRateIndex = Math.max(0, this.currentRateIndex - 1);
  }

  get rates(): FormArray {
    return this.ratesDetailsGroup.get('rates') as FormArray;
  }

  navigateToRates(index: number) {
    if (index >= 0 && index < this.rates.length) {
      this.currentRateIndex = index;
    }
  }

  onStepChange(event: StepperSelectionEvent) {
    this.currentStepIndex = event.selectedIndex;
    this.updateNavigation();
  }

  isStepEditable(index: number): boolean {
    return this.currentStepIndex === index;
  }

  previousStep() {
    if (this.stepper) {
      this.stepper.previous();
      this.updateNavigation();
    }
  }

  nextStep() {
    if (this.stepper) {
      this.stepper.next();
      this.updateNavigation();
    }
  }

  updateNavigation() {
    if (this.stepper) {
      this.canGoBack = this.stepper.selectedIndex > 0;
      this.canGoForward = this.stepper.selectedIndex < this.stepper.steps.length - 1;
    }
  }

  firstFormSave() {
    if (this.employeeDetailsGroup.valid) {
      this.privateService.updateEmployeeDetails(this.employeeDetailsGroup.value).subscribe({
        next: res => {
          console.log(res);
          if (res) {
            this.showNotification("Saved Successfully");
          }
        },
        error: err => {
          console.log(err);
        }
      })
    }
  }

  secondFormSave() {
    if (this.scheduleDetailsGroup.valid) {
      const scheduleArray = this.scheduleDetailsGroup.get('schedules') as FormArray;
      const currentSchedule = scheduleArray.at(this.currentScheduleIndex);
      console.log(currentSchedule.value);
      this.privateService.updateScheduleDetails(currentSchedule.value).subscribe({
        next: res => {
          console.log(res);
          if (res) {
            this.privateService.getEmployeeScheduleDetails(this.data.C_BPartner_ID).subscribe({
              next: res => {
                if (res.length > 0) {
                  this.patchScheduleDetails(res);
                } else {
                  this.createScheduleFormGroup();
                }
              },
              error: err => {
                console.log(err);
                this.isLoading = false;
              }
            });
            this.showNotification("Saved successfully");
          } else {
            this.showNotificationError("Failed to save schedule");
          }
        },
        error: err => {
          console.log(err);
        }
      })
    }
  }

  thirdFormSave() {
    if (this.ratesDetailsGroup.valid) {
      this.privateService.updateAttributeDetails(this.ratesDetailsGroup.value.rates).subscribe({
        next: res => {
          if (res) {
            this.privateService.getEmployeeAttribute(this.data.C_BPartner_ID).subscribe({
              next: res => {
                if (res.length > 0) {
                  this.patchRatesDetails(res);
                } else {
                  this.createRatesFormGroup();
                }
              },
              error: err => {
                console.log(err);
                this.isLoading = false;
              }
            });
            this.showNotification("Saved Successfully");
          }
        },
        error: err => {
          console.log(err);
        }
      })
    }
  }

  fourthFormSave() {
    if (this.addressDetailsGroup.valid) {
      console.log(this.addressDetailsGroup.value);
      this.privateService.insertEmployeeAddress(this.addressDetailsGroup.value, this.data.C_BPartner_ID).subscribe({
        next: res => {
          if (res) {
            this.privateService.getEMployeeAddress(this.data.C_BPartner_ID).subscribe({
              next: res => {
                this.patchAddressDetails(res);
              },
              error: err => {
                console.log(err);
                this.isLoading = false;
              }
            });
            this.showNotification("Saved Successfully");
          }
        },
        error: err => {
          console.log(err);
        }
      })
    }
  }

  deleteWorkdaysDialog() {
    const scheduleArray = this.scheduleDetailsGroup.get('schedules') as FormArray;
    const currentSchedule = scheduleArray.at(this.currentScheduleIndex);
    const scheduleID = currentSchedule.get('scheduleID')?.value;

    if (scheduleID > 0) {
      const dialogData = {
        title: 'Delete Schedule',
        content: "Delete this schedule?",
        cancelText: 'Cancel',
        confirmText: 'Delete',
        employeeWorkDaysID: scheduleID,
        status: 'Delete',
        C_BPartner_ID: this.data.C_BPartner_ID
      };
      this.dialogWorkdaysService.openDialog(dialogData).subscribe((result) => {
        if (result) {

        }
      });
      this.dialogRef.close();
    }
  }

  showNotificationError(text) {
    this.toastr.success('<span class="now-ui-icons ui-1_bell-53"></span> ' + text + '', '', {
      timeOut: 3000,
      closeButton: true,
      enableHtml: true,
      toastClass: "alert alert-danger alert-with-icon",
      positionClass: 'toast-' + 'top' + '-' + 'center'
    });
  }

  showNotification(text) {
    this.toastr.success('<span class="now-ui-icons ui-1_bell-53"></span> ' + text + '', '', {
      timeOut: 3000,
      closeButton: true,
      enableHtml: true,
      toastClass: "alert alert-success alert-with-icon",
      positionClass: 'toast-' + 'top' + '-' + 'center'
    });
  }

  getRegions(id: number) {
    this.authService.getRegion(id).subscribe({
      next: res => {
        this.regions = res;
        this.addressDetailsGroup.get('region')?.reset();
        this.regionCtrl.setValue('');
        this.filteredRegions = this.regionCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this._filterRegions(value || ''))
        );
      },
      error: err => {
        console.log(err);
      }
    })
  }

  getProvinces(id: number) {
    this.authService.getProvince(id).subscribe({
      next: res => {
        this.provinces = res;
        this.addressDetailsGroup.get('province')?.reset();
        this.filteredProvinces = this.provinceCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this._filterProvinces(value || ''))
        );
      },
      error: err => {
        console.log(err);
      }
    })
  }

  getProvincesOther(regionId: number, selectedProvince: number | null = null): void {
    this.authService.getProvince(regionId).subscribe({
      next: (res) => {
        this.provinces = res;
        this.filteredProvinces = this.provinceCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this._filterProvinces(value || ''))
        );
        if (selectedProvince !== null) {
          this.addressDetailsGroup.patchValue({ province: selectedProvince });
          const province = this.provinces.find(p => p.id === selectedProvince);
          this.provinceCtrl.setValue(province?.name || '');
        } else {
          this.addressDetailsGroup.get('province')?.reset();
        }
      },
      error: (err) => {
        console.log('Error fetching provinces:', err);
      },
    });
  }
}
